import { useI18n } from '@/i18n/context';

const LanguageSwitcher = () => {
  const { locale, setLocale } = useI18n();

  return (
    <div className="flex items-center bg-muted/50 rounded-lg p-0.5" role="group" aria-label="Language switcher">
      <button
        onClick={() => setLocale('es')}
        className={`px-2.5 py-1 rounded-md text-xs font-heading font-semibold tracking-wider transition-all duration-200 ${
          locale === 'es' ? 'bg-card text-primary shadow-sm' : 'text-muted-foreground hover:text-foreground'
        }`}
        aria-label="Español"
        aria-pressed={locale === 'es'}
      >ES</button>
      <button
        onClick={() => setLocale('en')}
        className={`px-2.5 py-1 rounded-md text-xs font-heading font-semibold tracking-wider transition-all duration-200 ${
          locale === 'en' ? 'bg-card text-primary shadow-sm' : 'text-muted-foreground hover:text-foreground'
        }`}
        aria-label="English"
        aria-pressed={locale === 'en'}
      >EN</button>
    </div>
  );
};

export default LanguageSwitcher;
